import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PhoneCall } from "@phosphor-icons/react";

const SNOOZE_MS = 30 * 60 * 1000;

export function DdclReminder() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [ask, setAsk] = useState(null);
  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get("/ddcl/pending");
        const kind = data.checkout > 0 ? "checkout" : data.checkin > 0 ? "checkin" : null;
        if (!kind) return setAsk(null);
        const key = `ddcl-snooze-${data.date}-${kind}`;
        if (Date.now() < Number(localStorage.getItem(key) || 0)) return;
        setAsk({ kind, count: data[kind], key });
      } catch (e) {}
    };
    check();
    const i = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(i);
  }, []);
  if (!ask || pathname === "/ddcl") return null;
  const later = () => { localStorage.setItem(ask.key, String(Date.now() + SNOOZE_MS)); setAsk(null); };
  const isIn = ask.kind === "checkin";
  return (
    <Dialog open onOpenChange={(o) => !o && later()}>
      <DialogContent className="bg-white border-slate-200 max-w-md" data-testid="ddcl-reminder">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><PhoneCall size={20} className="text-blue-600" weight="duotone" />{isIn ? "8:00 AM check-in calls" : "5:00 PM check-out calls"}</DialogTitle>
          <DialogDescription>Did you make your {isIn ? "check-in" : "check-out"} call? {ask.count} assigned carrier{ask.count > 1 ? "s" : ""} still need{ask.count > 1 ? "" : "s"} one logged today.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={later} className="border-slate-300 bg-white text-slate-700" data-testid="ddcl-reminder-later">Remind me in 30 min</Button>
          <Button onClick={() => { later(); navigate("/ddcl"); }} className="bg-blue-600 text-white hover:bg-blue-700" data-testid="ddcl-reminder-open">Log calls now</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
